import { COOKIE_KEYS } from './CookiesManager'

export const COOKIE_DESCRIPTIONS = {
  ESSENTIAL: [
    {
      key: COOKIE_KEYS.AUTH,
      descriptionKey: 'cookies.sg_auth',
    },
    {
      key: COOKIE_KEYS.AGE_VERIFICATION,
      descriptionKey: 'cookies.sg_age',
    },
    {
      key: COOKIE_KEYS.FUNCTIONAL,
      descriptionKey: 'cookies.sg_functional',
    },
    {
      key: COOKIE_KEYS.LOGIN_HINT,
      descriptionKey: 'cookies.sg_login',
    },
    {
      key: COOKIE_KEYS.BANNER_HIDED,
      descriptionKey: 'cookies.bannerHided',
    },
  ],
  ANALYTICS: [
    {
      key: COOKIE_KEYS.ANALYTICS,
      descriptionKey: 'cookies.analytical-description',
    },
    {
      key: 'sentry-sc',
      descriptionKey: 'cookies.sentry_config',
    },
    {
      key: 'sentry-sudo',
      descriptionKey: 'cookies.sentry_permissions',
    },
    {
      key: 'AMP',
      descriptionKey: 'cookies.sentry_amp',
    },
    {
      key: 'AMP_MKTG',
      descriptionKey: 'cookies.sentry_amp_mktg',
    },
    {
      key: 'gsID',
      descriptionKey: 'cookies.sentry_gsid',
    },
    {
      key: 'session',
      descriptionKey: 'cookies.stripe_session',
    },
    {
      key: '__stripe_mid',
      descriptionKey: 'cookies.stripe_mid',
    },
  ],
}
